import { DisposersStore } from 'stores';

import { UserProfile } from './userProfileStore';

const disposers = new DisposersStore();
const userProfileStore = new UserProfile();

export { disposers, userProfileStore };
